import * as Sentry from '@sentry/vue';

/**
 * @author: Omar Sánchez Martinez
 * @since: 26/05/2025
 * @description: Configura el usuario de Sentry
 */
export const configureSentryUser = (user: { id: string | number; email: string }) => {
  const ipAddress = window.location.hostname;
  
  // Configure Sentry user information for better error tracking
  Sentry.setUser({
    id: user.id,
    email: user.email,
    ip_address: ipAddress,
  });
}; 

/**
 * @author: Omar Sánchez Martinez
 * @since: 26/05/2025
 * @description: Limpia el usuario de Sentry
 */
export const clearSentryUser = () => {
  Sentry.setUser(null);
};